import React from 'react';
import "./header.css";
import { isMobile, getBrandLogoUrl } from '../../../utils';

function Header( { backgroundColor } ) {
    const logoUrl = window.location.pathname === "/jobs" && !isMobile()  ?  getBrandLogoUrl('dark'): getBrandLogoUrl('white');
    
    return (
      <div className={`uc-navbar-wrapper`} style={{backgroundColor: backgroundColor}}>
      <nav className="navbar navbar-expand-md uc-navbar">
        <a href="https://www.urbancompany.com/" >
          <div className="logo-box">
            <img id="uc-logo" src={logoUrl} />
          </div> 
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
        >
          <i className="fa fa-bars"></i>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav">
            <li className="nav-item">
              <a className="nav-link" href="https://partner.urbancompany.com/?utm_source=Customer_web&utm_campaign=header&utm_medium=homepage" target="_blanlk">
                Become a Partner
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="https://www.urbancompany.com/about" target="_blanlk">
                About us
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="mailto:help@urbancompany.com" target="_blanlk">
                Help
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default Header;
